// 外部サービスの接続先と、相談先（専門家）の紹介情報。
// どれも Cloudflare Pages の環境変数（REACT_APP_〜）で入れる。空の間はその導線・表示は画面に出ないので、
// 予約ページやLINEの準備ができる前にマージしても、本番の見た目は変わらない。

// 専門家（提携行政書士）の予約ページ（TimeRex）。公開されている予約用のURLなので、ここに既定値として持つ。
// 差し替えるときは環境変数 REACT_APP_TIMEREX_URL で上書きできる
export const TIMEREX_URL = process.env.REACT_APP_TIMEREX_URL || "https://timerex.net/s/tm.maruyama63_3913/5ca2897e";

// 農援LINE（LINE Harness）の友だち追加の入口。例: https://<Harnessのドメイン>/auth/line
export const LINE_ENTRY_URL = process.env.REACT_APP_LINE_ENTRY_URL || "";

// 相談先の専門家。名前・顔写真・実績は、ご本人の確認が取れたものだけを入れる
export const EXPERT = {
  name:   process.env.REACT_APP_EXPERT_NAME   || "",
  title:  process.env.REACT_APP_EXPERT_TITLE  || "",   // 例: 行政書士
  office: process.env.REACT_APP_EXPERT_OFFICE || "",
  photo:  process.env.REACT_APP_EXPERT_PHOTO  || "",   // 画像のURL
  site:   process.env.REACT_APP_EXPERT_SITE   || "",   // 事務所・会社のページ
  // 実績は「|」区切りで複数（例: 農業の補助金申請 ◯件|スマート農業の導入支援）
  achievements: (process.env.REACT_APP_EXPERT_ACHIEVEMENTS || "").split("|").map((a) => a.trim()).filter(Boolean),
};

// 農援LINEの友だち追加URLを作る。ref は LINE 側の「流入経路」、あとは「何をしたい人か・どの県か」を持ち回る
export function lineEntryUrl(ref, { goal, pref } = {}) {
  if (!LINE_ENTRY_URL) return "";
  const q = new URLSearchParams({ ref, utm_source: "hojokin-bot", utm_medium: "app" });
  if (goal) q.set("utm_campaign", goal);
  if (pref) q.set("utm_content", pref);
  return `${LINE_ENTRY_URL}?${q.toString()}`;
}
